var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 30,
    fill: "url(#pattern0_433_57)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_433_57",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_433_57",
    transform: "matrix(0.01 0 0 0.00666667 0 0.166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_433_57",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACA0lEQVR4nO3bQWoUQRiG4W/jOohBZilEmHV0PIFewFX+vZBLuHDhIjhGt4PoAXIJQRMQXHgGITlGSEoKShianu6ekEx9k34f+DfFJN1db5puGCIBAAAAAAAAAADA3WNJ7yS9lfSo9smM3VNJF5JSmfOyhgqeSPq7FOP/5EBEMYmRiOIXIxHFL0Yiil+MRBS/GIkod/9qm5bmz8A13r42cGd8lBQt63ntPVE2H0MdQTKibDhGX5CMKLdgr+OZcdT4bF8QlZ9Z9UzJx0KPXwNjDA3SFeU3Nbo9kHQ1MMY6QVZFuSrHRIefA2OsG6QtyndKDPt+45ukH5IOez67bpDsTfndX8uxcIviBkFwh4IgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXoIgXg5aguQ1VPKsJcg+Neo6lnRdZvl/R1DRThkAGOC1pBNJnyTtjmjHdss1n5Q9sPCq8ZZzqvE4a1z7Sxn43Dip65E8YHdaXrnzXlS3aDmxie6/Sct1572ojiAiiAPuEDMEMUMQMwQxQxAzBDFDEDMEMUMQM1sVZCrp4T2f6TYFGessZIAg8goyN/jLTCbzQQZeSLo02IxUefIezGRiVu6ULyOduaTntSMAAAAAAAAAAABoC/wDcwYVizdP+48AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.49422c913cd2cf120505e5ad37081128.svg";
export { ForwardRef as ReactComponent };